<template>
  <v-toolbar app>
    <v-toolbar-side-icon v-if="show" v-on:click.prevent="toggleDrawer()"> </v-toolbar-side-icon>
    <v-toolbar-title>{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="isLoggedIn" class="hidden-sm-and-down">
      <v-btn flat v-on:click.prevent="signOut()">Sign Out</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
/*global firebase*/
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      title: null
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "isNorgAdmin", "isLoggedIn"]),
    show() {
      return this.isAdmin || this.isNorgAdmin
    }
  },
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },
  created() {
    this.title = this.$route.name
  },
  methods: {
    toggleDrawer() {
      this.$store.commit('setDrawer', !this.$store.getters.drawer)
    },
    signOut() {
      firebase.auth().signOut();
    }
  }
};
</script>
